import React from "react";
import { Link } from "react-router-dom";
import { Cake, Instagram, Facebook, Mail, Phone, MapPin, Heart } from "lucide-react";
import { contactInfo } from "../data/mock";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      {/* Decorative top border */}
      <div className="h-1 bg-gradient-to-r from-[#E5007D] via-[#D4AF37] to-[#E5007D]" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#E5007D] to-[#ff6bac] flex items-center justify-center">
                <Cake className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="font-playfair text-sm text-[#ff6bac]">Ma commande</p>
                <p className="font-playfair font-bold tracking-wide">PÂTISSERIE NGOUSSI</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Pâtissière de formation et passionnée par le cake design, je crée des
              gâteaux uniques pour vos moments exceptionnels.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-playfair text-lg font-semibold mb-4 text-[#D4AF37]">Navigation</h3>
            <ul className="space-y-2">
              {[
                { name: "Accueil", path: "/" },
                { name: "Mes réalisations", path: "/realisations" },
                { name: "Tarifs", path: "/tarifs" },
                { name: "Commande", path: "/commande" },
                { name: "Avis clients", path: "/avis" },
                { name: "Contact", path: "/contact" },
              ].map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-[#E5007D] transition-colors duration-300 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-playfair text-lg font-semibold mb-4 text-[#D4AF37]">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <Mail className="w-4 h-4 text-[#E5007D] flex-shrink-0" />
                {contactInfo.email}
              </li>
              {contactInfo.phone && <li className="flex items-center gap-3 text-gray-400 text-sm">
                <Phone className="w-4 h-4 text-[#E5007D] flex-shrink-0" />
                {contactInfo.phone}
              </li>}
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <MapPin className="w-4 h-4 text-[#E5007D] flex-shrink-0" />
                {contactInfo.address}
              </li>
            </ul>
          </div>

          {/* Hours & Social */}
          <div>
            <h3 className="font-playfair text-lg font-semibold mb-4 text-[#D4AF37]">Horaires</h3>
            <ul className="space-y-2 text-gray-400 text-sm mb-6">
              <li>{contactInfo.hours.weekdays}</li>
              <li>{contactInfo.hours.saturday}</li>
              <li>{contactInfo.hours.sunday}</li>
            </ul>
            {(contactInfo.instagram || contactInfo.facebook) && (
              <>
                <p className="mb-3 text-xs font-medium uppercase tracking-wider text-gray-500">Retrouvez-nous</p>
                <div className="mb-4 space-y-2">
                  {contactInfo.instagram && <a href={contactInfo.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-gray-400 transition-colors duration-300 hover:text-[#E5007D]"><Instagram className="h-4 w-4" /> Instagram</a>}
                  {contactInfo.facebook && <a href={contactInfo.facebook} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-gray-400 transition-colors duration-300 hover:text-[#E5007D]"><Facebook className="h-4 w-4" /> Facebook</a>}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-3">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} Pâtisserie Ngoussi. Tous droits réservés.
            </p>
            <p className="text-gray-500 text-sm flex items-center gap-1">
              Fait avec <Heart className="w-4 h-4 text-[#E5007D] fill-[#E5007D]" /> et beaucoup de sucre
            </p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-4 pt-3 border-t border-gray-800">
            <Link
              to="/mentions-legales"
              className="text-gray-500 hover:text-[#E5007D] transition-colors duration-300 text-xs"
            >
              Mentions légales
            </Link>
            <span className="text-gray-700 text-xs">|</span>
            <Link
              to="/conditions-commande"
              className="text-gray-500 hover:text-[#E5007D] transition-colors duration-300 text-xs"
            >
              Conditions de commande
            </Link>
            <span className="text-gray-700 text-xs">|</span>
            <Link
              to="/mentions-legales"
              className="text-gray-500 hover:text-[#E5007D] transition-colors duration-300 text-xs"
            >
              Données personnelles
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
